<template>
  <div class="record main-content">
    <div class="filter-content">
      <div class="time-content">
        <el-col class="line" :span="4">录入时间</el-col>
        <el-col :span="9">
          <el-date-picker type="date" placeholder="开始日期" value-format="timestamp" :picker-options="pickerOptionEntryStart"
                          v-model="rev_start" style="width: 100%;"></el-date-picker>
        </el-col>
        <el-col class="line" :span="2">至</el-col>
        <el-col :span="9">
          <el-date-picker type="date" placeholder="结束日期" value-format="timestamp" :picker-options="pickerOptionEntryEnd"
                          v-model="rev_end" style="width: 100%;"></el-date-picker>
        </el-col>
      </div>
      <div class="time-content">
        <el-col class="line" :span="4">建议时间</el-col>
        <el-col :span="9">
          <el-date-picker type="date" placeholder="开始" value-format="timestamp" v-model="diagnose_start" :picker-options="pickerOptionProjStart"
                          style="width: 100%;"></el-date-picker>
        </el-col>
        <el-col class="line" :span="2">至</el-col>
        <el-col :span="9">
          <el-date-picker type="date" placeholder="结束日期" value-format="timestamp" :picker-options="pickerOptionProjEnd"
                          v-model="diagnose_end" style="width: 100%;"></el-date-picker>
        </el-col>
      </div>
      <el-button type="primary" class="search-btn" @click="searchHandle">搜索</el-button>
      <el-button type="success" class="search-btn export-btn" @click="getDownloadUrl" :disabled="download_dis">批量下载</el-button>
    </div>
    <el-table
      :data="listData"
      v-loading="loading"
      border
      @selection-change="selectHandle"
      header-row-class-name="change-header-style"
      height="490"
      style="width: 100%;margin-top: 20px;">
      <el-table-column
					type="selection"
					width="40"
          :selectable="selectInit"
          fixed="left">
			</el-table-column>
      <el-table-column
        type="index"
        :index="indexHandle"
        label="序号"
        width="50"
        fixed="left">
      </el-table-column>
      <el-table-column
        prop="strProjectName"
        width="280"
        label="项目名称"
        fixed="left">
        <template slot="header" slot-scope="scope">
          <el-input @keyup.enter.native="searchHandle" v-model="proj_name_search" placeholder="项目名称" clearable size="mini">
            <i slot="prefix" class="el-input__icon el-icon-search" @click="searchHandle" style="cursor: pointer;"></i>
          </el-input>
        </template>
      </el-table-column>
      <el-table-column
        prop="strCustomerName"
        label="客户姓名"
        width="140"
      fixed="left">
        <template slot="header" slot-scope="scope">
          <el-input @keyup.enter.native="searchHandle" v-model="user_name_search" placeholder="客户姓名" clearable size="mini">
            <i slot="prefix" class="el-input__icon el-icon-search" @click="searchHandle" style="cursor: pointer;"></i>
          </el-input>
        </template>
      </el-table-column>
      <el-table-column
        prop="strCustomerGender"
        width="50"
        label="性别">
      </el-table-column>
      <el-table-column
        width="50"
        prop="nCustomerAge"
        label="年龄">
      </el-table-column>
      <el-table-column
        prop="strExpertName"
        label="专家姓名"
        width="120">
      </el-table-column>
      <el-table-column
        prop="nStatus"
        label="记录状态"
        width="120">
        <template slot="header" slot-scope="scope">
          <el-select popper-class="new_filter_options" v-model="cur_state_select" placeholder="记录状态" size="mini"
                     @change="searchHandle">
            <el-option
              v-for="item in cur_state_options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :style="{ '--bgcolor': (item.attr && item.attr.color) ? item.attr.color : '#ffffff' }">
            </el-option>
          </el-select>
        </template>
        <template slot-scope="scope">
          <p v-if="getOrderStateItem(scope.row.nStatus)"
             :style="'padding:4px 8px;background:' + ((getOrderStateItem(scope.row.nStatus).attr && getOrderStateItem(scope.row.nStatus).attr.color) || getOrderStateItem(scope.row.nStatus).color || '') + ';color:#fff;text-align: center;border-radius: 4px;'">
            {{ getOrderStateItem(scope.row.nStatus).name }}
          </p>
        </template>
      </el-table-column>
      <el-table-column
        prop="nExamineStatus"
        label="审核状态"
        width="120">
        <template slot="header" slot-scope="scope">
          <el-select v-model="examine_state_select" placeholder="审核状态" popper-class="new_filter_options" size="mini"
                     @change="searchHandle">
            <el-option
              v-for="item in examine_state_options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :style="{ '--bgcolor': (item.attr && item.attr.color) ? item.attr.color : '#ffffff' }">
            </el-option>
          </el-select>
        </template>
        <template slot-scope="scope">
          <div v-if="getExamineStateItem(scope.row.nExamineStatus)"
               :style="'padding:4px 8px;background:' + ((getExamineStateItem(scope.row.nExamineStatus).attr && getExamineStateItem(scope.row.nExamineStatus).attr.color) || getExamineStateItem(scope.row.nExamineStatus).color || '') + ';color:#fff;text-align: center;border-radius: 4px;'">
            {{ getExamineStateItem(scope.row.nExamineStatus).name }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        prop="nLevel"
        width="110"
        label="报告级别">
        <template slot="header" slot-scope="scope">
          <el-select popper-class="new_filter_options" v-model="rpt_level_select" placeholder="报告级别" size="mini"
                     @change="searchHandle">
            <el-option
              v-for="item in rpt_level_options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :style="{ '--bgcolor': (item.attr && item.attr.color) ? item.attr.color : '#ffffff' }">
            </el-option>
          </el-select>
        </template>
        <template slot-scope="scope">
          <div v-if="getRptLevelItem(scope.row.nLevel)"
               :style="'padding:4px 8px;background:' + ((getRptLevelItem(scope.row.nLevel).attr && getRptLevelItem(scope.row.nLevel).attr.color) || getRptLevelItem(scope.row.nLevel).color || '') + ';color:#fff;text-align: center;border-radius: 4px;'">
            {{ getRptLevelItem(scope.row.nLevel).name }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        width="160"
        prop="nReceiveTime"
        label="录入时间">
        <template slot-scope="scope">
          <div v-if="scope.row.nReceiveTime != 0 && scope.row.nReceiveTime != null">
            {{ scope.row.nReceiveTime | FormatDate('yyyy-MM-dd hh:mm:ss') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="strCustomerMobile"
        label="手机号码"
        width="120">
      </el-table-column>
      <el-table-column
        prop="strCheckCode"
        width="120"
        label="识别码">
      </el-table-column>
      <el-table-column
        prop="strDevCode"
        label="设备编码"
        width="160">
      </el-table-column>
      <el-table-column
        width="160"
        prop="nReportTime"
        label="建议时间">
        <template slot-scope="scope">
          <div v-if="scope.row.nReportTime != 0 && scope.row.nReportTime != null">
            {{ scope.row.nReportTime | FormatDate('yyyy-MM-dd hh:mm:ss') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="strCheckupCode"
        label="客户编码"
        width="210">
        <template slot="header" slot-scope="scope">
          <el-input @keyup.enter.native="searchHandle" v-model="exam_code_search" placeholder="客户编码" clearable size="mini">
            <i slot="prefix" class="el-input__icon el-icon-search" @click="searchHandle" style="cursor: pointer;"></i>
          </el-input>
        </template>
      </el-table-column>
      <el-table-column
        width="170"
        label="操作"
        fixed="right">
        <template slot-scope="scope">
          <el-button type="warning" title="操作记录" icon="el-icon-s-order"
                     @click="showOperationDia(scope.row)"></el-button>
          <el-button type="success" title="缩略图" icon="el-icon-view"
                     @click="showPicHandle(scope.row)"></el-button>
          <el-button type="primary" title="下载报告" icon="el-icon-download"
                     @click="downloadReportHandle(scope.row)" v-if="scope.row.nStatus === 30"></el-button>
        </template>
      </el-table-column>
      <template slot="empty">
        <div class="no-data">
          当前暂无数据
        </div>
      </template>
    </el-table>
    <page-nation :total="page_total" @pageChange="pageChange" :current_page="current_page" :page_sizes="page_sizes"
                 :page_limit="page_limit"></page-nation>

    <el-dialog
      :visible.sync="showPreviewDialog"
      title="预览图像"
      width="840px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      style="padding-bottom: 10px;"
      custom-class="line-dialog"
      show-close>
      <div class="dia-load">
        <heart-iframe ref="canvasView" @changeCurPage="changeCurPage" :etc_url="file_name" :file_size="file_size"></heart-iframe>
      </div>
    </el-dialog>

    <operation-record ref="operation_record"></operation-record>

  </div>
</template>

<script>
import PageNation from "./Common/PageNation";
import OperationRecord from "./Common/OperationRecord";
import HeartIframe from "./Common/HeartIframe";
import ApiService from "../service/ApiService";
import pub from "../service/public";

// 常量定义
const ORDER_STATUS = {
  PENDING: 30,
  COMPLETED: 400
};

export default {
  name: "RecordList",
  components: {
    PageNation: PageNation,
    OperationRecord:OperationRecord,
    HeartIframe:HeartIframe,
  },
  data(){
    return {
      rev_start: '',  // 录入时间
      rev_end: '',
      pickerOptionEntryStart: {
        disabledDate: time => {
          if (this.rev_end) {
            return time.getTime() > new Date(this.rev_end).getTime();
          } else {
            return time.getTime() > Date.now();
          }
        }
      },
      pickerOptionEntryEnd: {
        disabledDate: time => {
          if (this.rev_start) {
            return time.getTime() < new Date(this.rev_start).getTime() || time.getTime() > Date.now();
          } else {
            return time.getTime() > Date.now();
          }
        }
      },
      diagnose_start: '',  // 建议时间
      diagnose_end:'',
      pickerOptionProjStart: {
        disabledDate: time => {
          if (this.diagnose_end) {
            return time.getTime() > new Date(this.diagnose_end).getTime();
          } else {
            return time.getTime() > Date.now();
          }
        }
      },
      pickerOptionProjEnd: {
        disabledDate: time => {
          if (this.diagnose_start) {
            return time.getTime() < new Date(this.diagnose_start).getTime() || time.getTime() > Date.now();
          } else {
            return time.getTime() > Date.now();
          }
        }
      },
      listData: [],
      loading: false,
      page_total:0,
      current_page: 1,
      page_sizes: [10, 20, 50, 100],
      page_limit: 10, // 每页多少条
      proj_name_search:'',
      user_name_search:'',
      exam_code_search:'',
      cur_state_select:-1,
      cur_state_options:[],
      showPreviewDialog: false,
      file_name: '',
      file_size:0,
      examine_state_options:[],
      examine_state_select:-1,
      rpt_level_select: -1,
      rpt_level_options:[],
      download_dis:false,
      batch_list:[],
    }
  },
  created() {
    this.initConstOptions();
    this.initData();
  },
  methods:{
    // 提取时间参数处理逻辑
    buildTimeFrameParams() {
      let recv_start = this.rev_start ? this.rev_start / 1000 : 0;
      let recv_end = this.rev_end ? this.rev_end / 1000 : 0;
      let diagnose_start = this.diagnose_start ? this.diagnose_start / 1000 : 0;
      let diagnose_end = this.diagnose_end ? this.diagnose_end / 1000 : 0;

      // 改为返回时间条件数组，可同时传多个时间段
      const timeFrames = [];

      // 录入时间
      if (recv_start || recv_end) {
        timeFrames.push({
          nTimeType: 5,
          nStartTime: recv_start,
          nEndTime: recv_end,
        });
      }

      // 建议时间
      if (diagnose_start || diagnose_end) {
        timeFrames.push({
          nTimeType: 10,
          nStartTime: diagnose_start,
          nEndTime: diagnose_end,
        });
      }

      return timeFrames;
    },

    // 构建查询参数
    buildQueryParams(page = null) {
      const timeFrame = this.buildTimeFrameParams();

      return {
        page: page || {
          number: this.current_page - 1,
          limit: this.page_limit
        },
        keyWord: [],
        parms: {
          // 时间查询改为数组
          lsTimeFrame: timeFrame,
          strProjectName: this.proj_name_search,
          strCustomerName: this.user_name_search,
          strCheckupCode: this.exam_code_search,
          nStatus: this.cur_state_select,
          nExamineStatus: this.examine_state_select,
          nLevel: this.rpt_level_select,
        }
      };
    },

    // 统一错误处理
    handleError(error, context = '') {
      this.loading = false;
      const message = (error && error.response && error.response.data && error.response.data.message) ||
                      (error && error.message) ||
                      '请求失败';
      pub.tip(message, 'error');
    },

    indexHandle(index){
      index = (index + 1) + (this.current_page - 1) * this.page_limit;
      return index
    },

    pageChange(item) {
      this.current_page = item.current_page;
      if(item.type == 'size'){
        this.page_limit = item.page_limit;
      }
      this.initData(); //改变页码，重新渲染页面
    },

    selectInit(row){
      return row.nStatus === ORDER_STATUS.PENDING ? 1 : 0;
    },

    initData(){
      this.loading = true;
      this.listData = [];

      const params = this.buildQueryParams();

      ApiService.HeartRecordList(params).then(res => {
        this.loading = false;
        if (res.code === pub.backCode.SUCCESS) {
          this.listData = res.data.pageList;
          if(this.current_page == 1){
            this.page_total = res.data.itemTotal;
          }
        } else {
          pub.analysisReturnCode(res, this.initData);
        }
      }).catch(error => {
        this.handleError(error, '记录列表');
      });
    },
    // 搜索
    searchHandle() {
      this.current_page = 1;
      this.initData();
    },
    // 下载报告
    downloadReportHandle(val) {
      // 直接使用列表返回的 PDF 报告地址
      if (val.strMergeReportFileName) {
        const fileName = `报告_${val.strCustomerName}(${val.strCustomerGender})`;
        pub.fileLinkToStreamDownload(val.strMergeReportFileName, fileName, 'pdf');
      } else {
        pub.tip('该记录暂无报告，请联系相关人员', 'warning');
      }
    },
    // 缩略图
    showPicHandle(item) {
      // 直接使用列表返回的 AECG 文件地址
      if (item.strFileName) {
        this.file_name = item.strFileName;
        this.file_size = Number(item.nFileLength) * 1024;
        this.showPreviewDialog = true;
        this.$nextTick(() => {
          this.$refs.canvasView.sendMessage();
        });
      } else {
        pub.tip('该记录暂无缩略图，请联系相关人员', 'warning');
      }
    },
    // canvas子组件返回上，下一页点击状态及当前第几张canvas （从0开始）
    changeCurPage(item) {
      if (item.file_status == 404 || item.file_status == 'error') {
        this.showPreviewDialog = false;
        this.$message({
            showClose: true,
            message: "文件不存在,请重新上传",
            type: 'error',
            duration: 2000
        });
      } else {
        this.showPreviewDialog = true;
      }
    },
    //操作列表
    showOperationDia(item){
      this.$refs.operation_record.showOperationListDia(item);
    },
    // 初始化枚举选项
    initConstOptions() {
      let constData = pub.getConst();
      if (constData) {
        // 订单状态
        if (constData.orderState) {
          this.cur_state_options = [{value: -1, label: '记录状态'}].concat(
            constData.orderState.map(item => ({value: item.value, label: item.name,attr:item.attr}))
          );
        }
        // 审核状态
        if (constData.examineStatus) {
          this.examine_state_options = [{value: -1, label: '审核状态'}].concat(
            constData.examineStatus.map(item => ({value: item.value, label: item.name,attr:item.attr}))
          );
        }
        // 报告级别
        if (constData.rptLevel) {
          this.rpt_level_options = [{value: -1, label: '报告级别'}].concat(
            constData.rptLevel.heart.map(item => ({value: item.value, label: item.name,attr:item.attr}))
          );
        }
      }
    },
    // 获取订单状态枚举项
    getOrderStateItem(value) {
      return pub.getConstItem('orderState', value);
    },
    // 获取审核状态枚举项
    getExamineStateItem(value) {
      return pub.getConstItem('examineStatus', value);
    },
    // 获取报告级别枚举项
    getRptLevelItem(value) {
      const constData = pub.getConst();
      if (!constData || !constData.rptLevel || !constData.rptLevel.heart) {
        return null;
      }
      return constData.rptLevel.heart.find(item => item.value == value) || null;
    },
    // 从完整报告地址中截取日期后的相对路径
    getRptRelativePath(url) {
      if (!url) return '';
      // 去掉协议和域名，只保留域名后的路径
      // 例如: https://xxx.com/2024-10-15/rpt/xx.pdf -> 2024-10-15/rpt/xx.pdf
      const match = url.match(/^https?:\/\/[^/]+\/(.*)$/);
      if (match && match[1]) {
        return match[1];
      }
      return url;
    },
    // 获取选中的内容
    selectHandle(val){
      let templist = [];
      for (let i = 0; i < val.length; i++) {
        templist[i] = {
          ord_id: val[i].nOrderRecvId,
          exam_code: val[i].strCheckupCode,
          csr_name:val[i].strCustomerName,
          rpt_all_url:this.getRptRelativePath(val[i].strMergeReportFileName),
        };
      }
      this.batch_list = templist;
    },
    // 获取下载地址
    getDownloadUrl(){
      if(this.batch_list.length < 1){
        pub.tip('请选择要下载的记录', 'warning');
        return;
      }

      this.download_dis = true;
      const loading = this.$loading({
        lock: true,
        text: '正在下载...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      const params = {
        jobid:this.uuid(),
        filelist:this.batch_list,
      };

      ApiService.HeartRecordDownload(params).then(res => {
        this.download_dis = false;
        loading.close();
        if(res.code === 200){
          if (res.data) {
            const fileUrl = res.data;
            const date = new Date();
            const day = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
            pub.fileLinkToStreamDownload(fileUrl, '报告批量下载'+day, 'zip');
          } else {
            pub.tip('未获取到批量下载地址，请检查筛选条件');
          }
        } else {
          pub.analysisReturnCode(res, this.getDownloadUrl);
        }
      }).catch(error => {
        this.download_dis = false;
        loading.close();
        this.handleError(error, '批量下载');
      });
    },

    uuid() {
        let s = [];
        let hexDigits = "0123456789abcdef";
        for (let i = 0; i < 36; i++) {
            s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
        s[8] = s[13] = s[18] = s[23] = "-";

        let uuid = s.join("");
        return uuid;
    },

  },
}
</script>

<style scoped lang="scss">
  .filter-content,.dia-load {
    text-align: left;
  }
  >>>.line-dialog .el-dialog__body{
      padding-top: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/RecordList.vue